import { useMemo } from "react";
import {
  EDITORIAL_DISCLAIMER,
  getRankingsPayload,
  RANKING_CRITERIA,
} from "@data/studios";
import { CriteriaSection } from "./components/CriteriaSection";
import { Hero } from "./components/Hero";
import { SiteFooter } from "./components/SiteFooter";
import { SiteHeader } from "./components/SiteHeader";
import { StructuredData } from "./components/StructuredData";
import { StudioCard } from "./components/StudioCard";
import styles from "./App.module.css";

export default function App() {
  const { studios, lastUpdated, reviewNotes } = useMemo(() => {
    const payload = getRankingsPayload();
    return {
      studios: payload.studios,
      lastUpdated: payload.lastUpdated,
      reviewNotes: payload.reviewNotes,
    };
  }, []);

  return (
    <div className={styles.page}>
      <StructuredData studios={studios} lastUpdated={lastUpdated} />
      <SiteHeader />
      <main>
        <Hero
          lastUpdated={lastUpdated}
          studios={studios}
          criteriaCount={RANKING_CRITERIA.length}
        />
        <section className="container" id="rankings" aria-labelledby="rankings-heading">
          <div className={styles.sectionHeading}>
            <div>
              <p className={styles.eyebrow}>2026 Editorial Rankings</p>
              <h2 id="rankings-heading">Top NYC Pottery Studios</h2>
            </div>
            <p className={styles.sectionLede}>
              Side-by-side comparison of {studios.length} well-known studios across five editorial
              criteria. Each studio leads in different areas, so use the category ratings
              and "best for" picks to weigh what matters most for how you want to learn.
            </p>
          </div>
          <ol className={styles.rankingList}>
            {studios.map((studio) => (
              <li key={studio.id}>
                <StudioCard studio={studio} />
              </li>
            ))}
          </ol>
          <p className={styles.disclaimer}>{EDITORIAL_DISCLAIMER}</p>
        </section>
        <CriteriaSection criteria={RANKING_CRITERIA} />
      </main>
      <SiteFooter lastUpdated={lastUpdated} reviewNotes={reviewNotes} />
    </div>
  );
}
